import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, computed, provide } from 'vue';
export default {
  __name: 'FocusTrap',
  props: {
    escCallback: {
      type: Function,
      required: false,
      default: () => {}
    },
    horizontalControls: {
      type: Boolean,
      required: false,
      default: false
    },
    selector: {
      type: String,
      required: false,
      default: 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    },
    disableTabLock: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const focusContainer = ref(null);
    const props = __props;
    const getFocusableElements = () => {
      return (Array.from(focusContainer.value?.querySelectorAll(props.selector)) ?? []).filter(item => item.checkVisibility() && item.closest('.focusContainer') === focusContainer.value);
    };
    const nextKey = computed(() => {
      return props.horizontalControls ? 'ArrowRight' : 'ArrowDown';
    });
    const prevKey = computed(() => {
      return props.horizontalControls ? 'ArrowLeft' : 'ArrowUp';
    });

    /**
     * Focus the next element in the focusable elements list.
     * If the current element is the last one, do nothing.
     */
    const focusNextElement = () => {
      const focusableElements = getFocusableElements();
      const currIndex = focusableElements.indexOf(document.activeElement);
      if (currIndex === -1) {
        return;
      }
      if (currIndex < focusableElements.length - 1) {
        focusableElements[currIndex + 1].focus();
      }
    };

    /**
     * Focus the previous element in the focusable elements list.
     * If the current element is the first one, do nothing.
     */
    const focusPrevElement = () => {
      const focusableElements = getFocusableElements();
      const currIndex = focusableElements.indexOf(document.activeElement);
      if (currIndex === -1) {
        return;
      }
      if (currIndex > 0) {
        focusableElements[currIndex - 1].focus();
      }
    };
    const handleKeydown = event => {
      const focusableElements = getFocusableElements();
      const firstItem = focusableElements[0];
      const lastItem = focusableElements[focusableElements.length - 1];
      const currIndex = focusableElements.indexOf(document.activeElement);
      switch (event.key) {
        case 'Tab':
          if (props.disableTabLock) {
            return;
          }
          if (event.shiftKey) {
            if (document.activeElement === firstItem) {
              event.preventDefault();
              event.stopPropagation();
              lastItem.focus();
            }
          } else {
            if (document.activeElement === lastItem) {
              event.preventDefault();
              event.stopPropagation();
              firstItem.focus();
            }
          }
          break;
        case prevKey.value:
          event.preventDefault();
          event.stopPropagation();
          if (currIndex > 0) {
            focusableElements[currIndex - 1].focus();
          } else {
            lastItem.focus();
          }
          break;
        case nextKey.value:
          event.preventDefault();
          event.stopPropagation();
          if (currIndex < focusableElements.length - 1) {
            focusableElements[currIndex + 1].focus();
          } else {
            firstItem.focus();
          }
          break;
        case 'Home':
          event.preventDefault();
          event.stopPropagation();
          firstItem.focus();
          break;
        case 'End':
          event.preventDefault();
          event.stopPropagation();
          lastItem.focus();
          break;
        case 'Escape':
          props.escCallback();
          break;
      }
    };

    /**
     * Trigger focus on the first focusable element inside the focusContainer.
     */
    const triggerFocus = () => {
      const focusableElements = getFocusableElements();
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    };
    __expose({
      triggerFocus,
      getFocusableElements
    });
    provide('focusTrap', {
      focusNextElement,
      focusPrevElement
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "focusContainer",
        ref: focusContainer,
        class: "focusContainer",
        onKeydown: handleKeydown
      }, [_renderSlot(_ctx.$slots, "default")], 544);
    };
  }
};